import { ILang, LangTypeEnum } from '../src/modules/lang/types/Lang';
import { ApiUrlVersionEnum } from './base/api/axios/AxiosEnums';

export const appConfig = {
  defaultApiVersion: ApiUrlVersionEnum.v1,

  accessTokenStorageKey: '_MFMessagesAccessToken', // _[projectName]AccessToken
  refreshTokenStorageKey: '_MFMessagesRefreshToken', // _[projectName]RefreshToken

  // Debug
  sentrySettings: {
    dsn: 'https://e62e13dc83be2fce70e4de63627e03a4@sentry.logicstars.ru/78',
  },

  // i18n
  langStorageKey: '_LSATLang', // _[projectName]Lang
  defaultLanguage: LangTypeEnum.RU,
  languages: [
    { title: 'Русский', lang: LangTypeEnum.RU },
    // { title: 'English', lang: LangType.EN },
  ] as ILang[],
};
